import cRequest from "@services/c-request"

interface PushNotificationProps {
  title: string
  body: string
  deviceid: string
  data?: Record<string, string>
}

const notificationPath = `${process.env.REACT_APP_BASE_URL}/notifications`

export const sendPushNotificationService = async (
  body: PushNotificationProps
) => {
  if (!body?.deviceid) return null

  return cRequest
    .post(`${notificationPath}/send-push-notification`, body)
    .then(function (response: any) {
      return response.data
    })
    .catch(function (error: any) {
      console.log(error)
      throw error
    })
}
